module.exports = __webpack_public_path__ + "media/智能--太阳能系统.287c6cc6.mp4";